import React from 'react'
import { withStyles, createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import { Paper, Typography, TextField, Icon, IconButton, LinearProgress, CircularProgress, Switch, FormControlLabel, AppBar, Toolbar, Tabs, Tab } from '@material-ui/core'
import Header from '../../components/Header'

const styles = theme => ({
  root: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'stretch'
  },
  content: {
  	padding: 20
  }
})

class Contact extends React.Component {
  constructor () {
    super()
  }

	render() {
		const { classes } = this.props
		return (
      <Paper className={classes.root} elevation={1}>
        <Header/>
        <div className={classes.content}>
        	<h1>Contact Us</h1>
        </div>
      </Paper>
		)
	}
}

export default withStyles(styles)(Contact)
